export default __webpack_public_path__ + "static/media/hanzo-icon.11c45fc6.webp";